type BrandMarkProps = {
  className?: string;
  title?: string;
};

export function BrandMark({ className, title }: BrandMarkProps) {
  return (
    <svg
      viewBox="303 232.5 1317.5 1218"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <path d="M 324.000 1139.500 L 809.000 933.500 L 833.500 920.000 L 1199.000 238.500 Z M 309.000 1114.500 L 596.500 708.000 L 628.000 370.500 L 441.500 721.000 Z M 341.000 1178.500 L 1175.000 1082.500 L 1614.500 767.000 L 1001.000 898.500 Z M 837.000 1444.500 L 1450.500 1391.000 L 723.000 1221.500 L 327.500 1208.000 Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
    </svg>
  );
}
